import './finance-forms.scss';

import { useContext } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { FileUpload } from '@/components/Shared/ui';
import { useAppSelector } from '@/store';

import { CreateTabContext } from '../../LlpOrder';
import type { CreateLeasingProps } from '../../widgets/create-tab';

const FinanceForms: React.FC = () => {
  const { files } = useAppSelector((state) => state.llpLeasingOrder);
  const { isFieldsFrozen } = useContext(CreateTabContext);
  const { control } = useFormContext<CreateLeasingProps>();

  if (isFieldsFrozen) {
    const filteredFiles = files.filter(
      (item) => item.name && item.type !== 'additionalFiles'
    );
    if (filteredFiles.length === 0) return null;
    return (
      <div className="create-tab__section">
        <h2>Формы финансовой отчетности</h2>
        <div className="finance-forms">
          {filteredFiles.map((file) => (
            <div key={file.uuid} className="finance-forms__file">
              {file.name}
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="create-tab__section">
      <h2>Формы финансовой отчетности</h2>
      <div className="finance-forms">
        <Controller
          control={control}
          name="balanceSheet"
          rules={{
            required: 'Пожалуйста, загрузите документ',
            validate: (document) => {
              if (!document?.base64) return 'Пожалуйста, загрузите документ';
            }
          }}
          render={({ field, fieldState: { error } }) => (
            <FileUpload
              {...field}
              title="Бухгалтерский баланс"
              accept=".pdf"
              allowedExtensions={['pdf']}
              error={error?.message}
              file={field.value}
              isRequired
              onDelete={() => field.onChange(null)}
            />
          )}
        />
        <Controller
          control={control}
          name="statement"
          rules={{
            required: 'Пожалуйста, загрузите документ',
            validate: (document) => {
              if (!document?.base64) return 'Пожалуйста, загрузите документ';
            }
          }}
          render={({ field, fieldState: { error } }) => (
            <FileUpload
              {...field}
              title="Отчет о прибылях и убытках"
              allowedExtensions={['pdf']}
              accept=".pdf"
              error={error?.message}
              file={field.value}
              isRequired
              onDelete={() => field.onChange(null)}
            />
          )}
        />
        <Controller
          control={control}
          name="financeReport"
          rules={{
            required: 'Пожалуйста, загрузите документ',
            validate: (document) => {
              if (!document?.base64) return 'Пожалуйста, загрузите документ';
            }
          }}
          render={({ field, fieldState: { error } }) => (
            <FileUpload
              {...field}
              title="Отчет о движениях средств"
              allowedExtensions={['pdf']}
              accept=".pdf"
              error={error?.message}
              file={field.value}
              isRequired
              onDelete={() => field.onChange(null)}
            />
          )}
        />
        <Controller
          control={control}
          name="fno"
          rules={{
            required: 'Пожалуйста, загрузите документ',
            validate: (document) => {
              if (!document?.base64) return 'Пожалуйста, загрузите документ';
            }
          }}
          render={({ field, fieldState: { error } }) => (
            <FileUpload
              {...field}
              title="ФНО"
              allowedExtensions={['pdf']}
              accept=".pdf"
              error={error?.message}
              file={field.value}
              isRequired
              onDelete={() => field.onChange(null)}
            />
          )}
        />
        <Controller
          control={control}
          name="creditHistory"
          rules={{
            required: 'Пожалуйста, загрузите документ',
            validate: (document) => {
              if (!document?.base64) return 'Пожалуйста, загрузите документ';
            }
          }}
          render={({ field, fieldState: { error } }) => (
            <FileUpload
              {...field}
              title="Кредитная история"
              allowedExtensions={['pdf']}
              accept=".pdf"
              error={error?.message}
              file={field.value}
              isRequired
              onDelete={() => field.onChange(null)}
            />
          )}
        />
        <Controller
          control={control}
          name="ocStatement"
          rules={{
            required: 'Пожалуйста, загрузите документ',
            validate: (document) => {
              if (!document?.base64) return 'Пожалуйста, загрузите документ';
            }
          }}
          render={({ field, fieldState: { error } }) => (
            <FileUpload
              {...field}
              title="Выписка по ОС"
              allowedExtensions={['pdf']}
              accept=".pdf"
              error={error?.message}
              file={field.value}
              isRequired
              onDelete={() => field.onChange(null)}
            />
          )}
        />
      </div>
    </div>
  );
};

export default FinanceForms;
